/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_cart_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Mezisoučet košíku`
};

const da_cart_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Kurv subtotal`
};

const de_cart_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Zwischensumme`
};

const en_cart_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Cart subtotal`
};

const es_cart_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Subtotal del carrito`
};

const fr_cart_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Sous-total du panier`
};

const hu_cart_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Kosár közvetítés`
};

const it_cart_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Subtotale carrello`
};

const nl_cart_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Subtotaal winkelwagen`
};

const pl_cart_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Suma częściowa koszyka`
};

const pt_cart_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Subtotal do carrinho`
};

const sv_cart_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Delsumma`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cart_subtotal = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cart_subtotal(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cart_subtotal", locale)
	if (locale === "cs") return cs_cart_subtotal(inputs)
	if (locale === "da") return da_cart_subtotal(inputs)
	if (locale === "de") return de_cart_subtotal(inputs)
	if (locale === "en") return en_cart_subtotal(inputs)
	if (locale === "es") return es_cart_subtotal(inputs)
	if (locale === "fr") return fr_cart_subtotal(inputs)
	if (locale === "hu") return hu_cart_subtotal(inputs)
	if (locale === "it") return it_cart_subtotal(inputs)
	if (locale === "nl") return nl_cart_subtotal(inputs)
	if (locale === "pl") return pl_cart_subtotal(inputs)
	if (locale === "pt") return pt_cart_subtotal(inputs)
	return sv_cart_subtotal(inputs)
};